<div class="row align-items-center g-2">
  <div class="col-auto my-1">
    <div class="input-group">
      <label class="input-group-text" for="selectSpecies">Species</label>
      <select class="form-select" id="selectSpecies" [(ngModel)]="selectedSpecies" (ngModelChange)="speciesChange()">
        @for (s of species; track s.name) {
          <option [ngValue]="s">{{s.name}}</option>
        }
      </select>
    </div>
  </div>
  @if (showGenomic()) {
    <div class="col-auto my-1">
      <div class="input-group">
        <label class="input-group-text" for="selectGenomic">Genomic locus</label>
        <select class="form-select" id="selectSpecies" [(ngModel)]="singleSelectedGen" (ngModelChange)="refSeqChange()">
          @for (s of datasets; track s.text) {
            <option [ngValue]="s">{{s.text}}</option>
          }
        </select>
      </div>
    </div>
  }
  @if (showAssembly()) {
    <div class="col-auto my-1" >
      <div class="input-group">
        <label class="input-group-text" for="selectAssembly" style="height: 38px">Genomic Assemblies</label>
        <ng-multiselect-dropdown id="selectAssembly"
          [class]="'selector-dropdown'"
          [settings] = genAssemblyDropdownSettings
          [data] = assemblies
          [(ngModel)] = selectedAssembly
          [placeholder] = "'Select Datasets'"
          (ngModelChange)="assemblyChange()"
          >
        </ng-multiselect-dropdown>
      </div>
    </div>
  }
  @if (showRepseq()) {
    <div class="col-auto my-1">
      <div class="input-group">
        <label class="input-group-text" for="selectRepSeq">AIRR-seq locus</label>
        <select class="form-select" id="selectRepSeq" [(ngModel)]="singleSelectedRep" (ngModelChange)="repSeqChange()">
          @for (s of repSeqs; track s.text) {
            <option [ngValue]="s">{{s.text}}</option>
          }
        </select>
      </div>
    </div>
  }
  @if (showCommon()) {
    <div class="col-auto my-1">
      <div class="input-group">
        <label class="input-group-text" for="selectCommon">Locus</label>
        <select class="form-select" id="selectCommon" [(ngModel)]="singleSelectedCommon" (ngModelChange)="commonChange()">
          @for (s of commonDatasets; track s.text) {
            <option [ngValue]="s">{{s.text}}</option>
          }
        </select>
      </div>
    </div>
  }
</div>

@if (isFetching) {
  <div  class="spinner-border" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
}


@if (error) {
  <div class="alert alert-danger">
    <div class="row">
      <h4>Error loading data: {{error}}</h4>
    </div>
  </div>
}
